/// Copyright (C) Microsoft Corporation. All rights reserved.

import {
    MeControlNamespace as PublicMeControlNamespace,
    IMeControlLoader,
    IPublicApiProxy,
} from '@mecontrol/public-api';
import { w, ME, assign, addStrings } from './utilities';
import { meDefine, meImport } from './amd/index';
import { MeControlNamespace as InternalMeControlNamespace } from '@mecontrol/common';

export function extendMe(...args: any[]): void {
    return assign(ME, ...args);
}

export function setPublicWindowApi(
    apiProxy: IPublicApiProxy,
    load: IMeControlLoader["load"],
    loadAsync: IMeControlLoader["loadAsync"]
): void {
    // Internal functions used by our custom AMD loader
    w.MeControlDefine = meDefine;
    w.MeControlImport = meImport;

    const MePublic: PublicMeControlNamespace = {
        API: apiProxy,
        Loader: {
            load,
            loadAsync
        },
        Config: ME.Config || {} as any
    };

    // Expose some internals on ME for backwards compat
    const MeInternal: Partial<InternalMeControlNamespace> = {
        Strings: {
            addStrings
        }
    };

    return extendMe(MePublic, MeInternal);
}
